/**
 * Ereignisse an Umami melden — für beide öffentlichen Auftritte.
 *
 * Ein Seitenaufruf sagt nichts darüber, ob aus dem Besuch etwas wird: Wer die
 * Telefonnummer antippt und anruft, hinterlässt sonst keine Spur. Genau diese
 * Schritte zählt die Auswertung in der Verwaltung als das, worauf es ankommt.
 *
 * Umami wird in `src/index.tsx` geladen und hängt danach als `window.umami`.
 * Fehlt es — Skript geblockt, Netz weg, Prerendering —, passiert hier schlicht
 * nichts. Ein fehlgeschlagenes Zählen darf niemals einen Klick verschlucken,
 * deshalb ist der ganze Aufruf zusätzlich in try/catch gefasst.
 *
 * Übertragen wird nur der Name des Ereignisses und die Stelle der Seite — nie
 * etwas, das jemand eingegeben hat. Die Datenschutzerklärung (Abschnitt 4)
 * beschreibt genau diese Liste; wer hier ein Ereignis ergänzt, ergänzt es dort.
 */
export function track(event: string, data?: Record<string, string | number>): void {
  try {
    const umami = (window as any).umami;
    if (typeof umami?.track === 'function') umami.track(event, data);
  } catch {
    /* Messung ist nie wichtiger als die Seite. */
  }
}

/**
 * Ereignisnamen der Kundenwebsite. Die Auswertung (`SeoAnalyticsService.PHONE_EVENTS`
 * im Backend) kennt dieselben Namen — sie sind Teil der Schnittstelle, nicht Kosmetik.
 */
export const SITE_EVENTS = {
  /** Telefonnummer angetippt (`tel:`-Link). */
  telefon: 'telefon',
  /** WhatsApp-Link geöffnet. */
  whatsapp: 'whatsapp',
  /** E-Mail-Adresse angetippt (`mailto:`-Link). */
  email: 'email',
  /** Kontaktformular erfolgreich abgeschickt. */
  anfrageGesendet: 'anfrage-gesendet',
} as const;
